import NotificationService from "../../Services/NotificationService";

export const GETNOTIFICATIONCOUNT = "GETNOTIFICATIONCOUNT";
export const GETNOTIFICATIONCOUNTFAILED = "GETNOTIFICATIONCOUNTFAILED";

export const getNotificationCount = () => async (dispatch) => {
  try {
    const loggedUserJson = localStorage.getItem("patientData");
    const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

    let payload = {
      patientId: loggedUser.patientId,
      countStatus: "N",
      status: 1,
    };

    const response = await NotificationService.NotificationCount(payload);
    dispatch({
      type: GETNOTIFICATIONCOUNT,
      payload: response.data?.TOTAL_COUNT_STATUS,
    });
  } catch (error) {
    dispatch({ type: GETNOTIFICATIONCOUNTFAILED });
  }
};
